import { DEFAULT, match } from '@/utils/pattern-match-util'
import type { PublishedLegendProps } from '@/features/jobs/legends/PublishedLegend'
import type {
  PublishedLegendResource,
  ServiceTypeResource,
} from '@/features/jobs/api/resources/legend'
import type { LegendServiceType } from '@/features/jobs/legends/legend-service-type'

export function mapPublishedLegendResourceToProps(
  resource: PublishedLegendResource,
): PublishedLegendProps {
  return {
    id: resource.id,
    version: resource.version,
    workspaceId: resource.workspace_id,
    name: resource.name,
    description: resource.description,
    inactive: resource.inactive,
    serviceType: mapServiceTypeResourceToServiceType(resource.service_type),
  }
}

export function mapServiceTypeResourceToServiceType(
  serviceType: ServiceTypeResource,
): LegendServiceType {
  return match(serviceType, {
    TAX: 'Tax',
    MISC: 'Misc',
    BOOKKEEPING: 'Bookkeeping',
    CONSULTATION: 'Consultation',
    [DEFAULT]: 'Tax',
  })
}
